<div class="custom-header" (dblclick)="toggleRollupGroup()">

  <span class="header-title" *ngIf="isRollupHeader===false">
    <span class="group-name" title="{{params.value}}">{{params.value}}</span>
    <span class="nhtp-link" *ngIf="this.newHireTrainingWeeks>0"><a href="#" (click)="this.showNhtpDialog($event)">{{this.newHireTrainingWeeks}} {{"multi.mu.group.nhtp"|translate}}</a></span>
    <span class="nhtp-link" *ngIf="this.newHireTrainingWeeks==0"><a href="#" (click)="this.showNhtpDialog($event)">{{"multi.mu.group.nhtp.no.value"|translate}}</a></span>
  </span>
  <button *ngIf="isRollupHeader"
    type="button"
    class="rollup-toggle"
    [attr.aria-expanded]="!isRollupCollapsed"
    (click)="toggleRollupGroup()">
    <span class="ag-icon"
          [ngClass]="isRollupCollapsed ? 'ag-icon-tree-closed' : 'ag-icon-tree-open'"
          aria-hidden="true"></span>
    <span>{{'multi.mu.rollup.group.header' | translate}}</span>
  </button>
  <!-- Add any custom elements you want here -->
</div>
